import { create } from "zustand";
import { IDeviceManagement } from "./IDeviceManagement";

const initial_value = {
  showMyDevicesModal: false,
  devicesList: [],
};
export const useDeviceManagementStore =
  create<IDeviceManagement.IDeviceManagementStore>((set) => ({
    ...initial_value,
    setShowMyDevicesModal: (value) =>
      set({
        showMyDevicesModal: value,
      }),
    setDevicesList: (value) =>
      set({
        devicesList: value,
      }),
    reset: () => {
      set(initial_value);
    },
  }));
